export default "__VITE_ASSET__esV_FSCY__"